<template>
    <div class="breadcrumb-nav">
        <span :class="{'show-cursor': path.length}" @click="back" v-if="path.length">Fexspace</span> &nbsp;<i class="fa fa-chevron-right" v-if="path.length"></i> <span v-for="(tray, index) in path" :key="tray.id" @click="browse(tray, index)" :title="tray.name" :class="{'show-cursor': path.length !== (index + 1)}"> {{ str_text(toTitleCase(tray.name)) }} &nbsp;<i class="fa fa-chevron-right" v-if="path.length !== (index + 1)"></i></span>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'

export default {
  props: ['path'],
  methods: {
    ...mapMutations([
      'SET_DB',
      'SET_CAN_CREATE',
      'SET_CREATE_RIGHT'
    ]),
    str_text (str) {
      if (str.length > 16) {
        return str.substr(0, 16) + '...'
      }

      return str
    },
    toTitleCase (text) {
      let txt = []
      text.split(' ').map(str => {
        txt.push(str.charAt(0).toUpperCase() + str.substring(1, str.length).toLowerCase())
      })

      return txt.join(' ')
    },
    browse (tray, index) {
      if (this.path.length === (index + 1)) {
        return
      }

      this.$emit('browse_dir', [tray.name, tray.id, tray.db, tray.file_type, tray.is_public, tray.can_create, tray.can_download, tray.can_upload])
    },
    back () {
      this.$parent.back()
    }
  },
  mounted () {

  }
}
</script>
